import React from "react";
import back from '../image/back.png';

const Incometax = () => {
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };
  return (
    <>
      <div className="bg-white rounded-lg">
        {/* Background Section */}
        <div
          className="bg-cover h-64 flex flex-col justify-center items-center text-center"
          style={{
            backgroundImage: `url(${back})`,
          }}
        >
          <h1 className="text-2xl md:text-3xl font-bold text-blue-700">
            Income Tax Return Filing
          </h1>
          <p className="mt-2 text-black font-semibold text-lg md:text-2xl px-4 md:px-0">
            Simplify Your Income Tax Returns Filing with Sanjay K Nathani & Co.
          </p>
        </div>

        {/* Description Section */}
        <div className="px-6 py-10 md:px-20 lg:px-40">
          <p className="text-gray-700 leading-relaxed mb-6 text-sm md:text-base">
            We provide quality Income tax consultancy and compliance with effective tax strategies, forming an integral part of our advisory. We provide income tax advice to companies as well as non-companies clients. We design, structure, and implement the tax planning most effectively according to the client suitability. Tax planning and advisory service is a very important function that we provide to many clients.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6 text-sm md:text-base">
            Our income tax returns filing services include:
          </p>

          {/* List of Services */}
          <ol className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
            <li>Preparation and filing of individual and business tax returns</li>
            <li>Tax planning to help you minimize your tax liabilities</li>
            <li>Assistance with tax refunds, if applicable</li>
            <li>Compliance with income tax regulations and requirements</li>
            <li>Representation before the tax authorities in case of any disputes or inquiries</li>
          </ol>

          <br />
          <p className="text-gray-700 leading-relaxed font-bold mt-6">Mandatory to File Income Tax Return</p>
          <br />
          
          {/* Mandatory Filing Reasons */}
          <ul className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
            <li>If your gross total income exceeds the basic exemption limit</li>
            <li>If TDS has been deducted from your income, you need to file an ITR to claim the credit for the TDS and get a refund if applicable.</li>
            <li>If you are a resident of India and have any assets or income outside India, you are required to file an ITR.</li>
            <li>Companies and firms are required to file ITRs regardless of their income or profit.</li>
            <li>If you receive a notice from the income tax department asking you to file an ITR, you must comply.</li>
            <li>Spending ₹2 lakh and above for foreign travel</li>
            <li>Paid electricity bill of ₹1 lakh in a financial year</li>
            <li>Deposited ₹1 crore in a current account</li>
            <li>If you have deposited more than ₹50 lakh in your savings bank accounts</li>
            <li>Your business turnover is more than ₹60 lakh</li>
            <li>Income from your profession is more than ₹10 lakh</li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="mt-8 bg-gray-50 p-6 rounded-lg shadow-sm mx-4 md:mx-20 lg:mx-40">
          <h2 className="text-lg md:text-xl font-bold text-gray-800 mb-4">Get in touch</h2>
          <p className="text-gray-600 mb-6 text-sm md:text-base">
            If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            {/* Make Appointment Button */}
            <button onClick={handleAppointmentClick}  className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200 w-full sm:w-auto">
              Make Appointment
            </button>

            {/* Contact Us Button */}
            <button className="px-6 py-2 bg-[#005A8C] text-white rounded  transition duration-200 w-full sm:w-auto">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Incometax;